export function formatDateJp(ms: number | string | Date | undefined): string {
  if (!ms && ms !== 0) return '';

  const date = new Date(ms);
  if (isNaN(date.getTime())) {
    return '';
  }

  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}
